




































































































































import { Component, Prop, Mixins, Watch } from 'vue-property-decorator';
import { Checkbox, FormItem, Option, Select } from 'element-ui';
import NullableInput from '@/components/element-ui/NullableInput.vue';
import UtcDatePicker from '@/components/element-ui/UtcDatePicker.vue';
import locations from '@/mixins/locationOptions.ts';
import LocationUpsertModal from '@/components/location/LocationUpsertModal.vue';
import {
  ShipmentFields,
  MilestoneInput,
  MilestoneFields,
  CustomerLocationFields
} from '@/types/graphql/schemaTypes';
import get from 'lodash/get';
import debounce from 'lodash/debounce';

@Component({
  components: {
    LocationUpsertModal,
    UtcDatePicker,
    'el-checkbox': Checkbox,
    'el-form-item': FormItem,
    'el-input': NullableInput,
    'el-option': Option,
    'el-select': Select
  }
})
export default class EventDateLocation extends Mixins(locations) {
  @Prop({ required: true }) private milestone!: MilestoneFields;
  @Prop({ required: true }) private shipment!: ShipmentFields;
  @Prop({ default: 'date' }) private dateType!: 'date' | 'datetime';

  private debouncer = debounce((self) => {
    self.$emit('update', self.milestoneInput);
  }, 300);

  private savedLocation: string | null = null;
  private showModal = false;

  public readonly customerOrganization: { id: string } = {
    id: this.shipment.customerOrganization.id
  };

  // From Container Information on "Details" page
  private readonly containerNumberOptions = [
    ...this.shipment.containerInformation
  ];

  private milestoneInput: MilestoneInput = {
    details: {
      containerDetails: {
        containerNumber: this.milestone?.details?.containerDetails?.containerNumber || null
      },
      drayageReserved: this.milestone?.details?.drayageReserved || false,
      eventLocation: get(this.milestone, 'details.eventLocation', null),
      locationCompanyName: get(
        this.milestone,
        'details.locationCompanyName',
        null
      ),
      locationCompanyPerson: get(
        this.milestone,
        'details.locationCompanyPerson',
        null
      ),
      locationCompanyPhone: get(
        this.milestone,
        'details.locationCompanyPhone',
        null
      )
    },
    truckingDetails: {
      companyName: this.milestone?.truckingDetails?.companyName || null,
      driverName: this.milestone?.truckingDetails?.driverName || null,
      truckNumber: this.milestone?.truckingDetails?.truckNumber || null,
      phoneNumber: this.milestone?.truckingDetails?.phoneNumber || null
    },
    eventDate: get(this.milestone, 'eventDate', null)
  };

  public handleCreation(newCustomerLocation: CustomerLocationFields) {
    this.customerLocationOptions.push(
      this.formatCustomerLocationOptions(newCustomerLocation)
    );
    if (!this.milestoneInput.details) {
      this.milestoneInput.details = {
        eventLocation: newCustomerLocation.fullAddress
      };
    } else if (this.milestoneInput.details.eventLocation === undefined) {
      this.milestoneInput.details.eventLocation =
        newCustomerLocation.fullAddress;
    }
  }

  private openCreationModal() {
    if (this.milestoneInput.details) {
      this.savedLocation = this.milestoneInput.details.eventLocation || null;
    }

    this.showModal = true;
  }

  private closeModal() {
    if (!this.milestoneInput.details) {
      this.milestoneInput.details = { eventLocation: this.savedLocation };
    } else if (this.milestoneInput.details.eventLocation === undefined) {
      this.milestoneInput.details.eventLocation = this.savedLocation;
    }

    this.showModal = false;
  }

  @Watch('milestoneInput.details.eventLocation')
  prefillDeliveryInfo(address: string) {
    // When Event Location is reset, other prefilled fields also reset
    if (!address) {
      this.milestoneInput.details.locationCompanyName = null;
      this.milestoneInput.details.locationCompanyPerson = null;
      this.milestoneInput.details.locationCompanyPhone = null;
    }

    // Auto-fill delivery information according to the selected address
    const matchedLocation = this.customerLocationOptions.filter(
      (location) => location.value.fullAddress === address
    );
    if (matchedLocation.length > 0) {
      this.milestoneInput.details.locationCompanyName =
        matchedLocation[0].value.name;
      this.milestoneInput.details.locationCompanyPerson =
        matchedLocation[0].value.contactName;
      this.milestoneInput.details.locationCompanyPhone =
        matchedLocation[0].value.contactNumber;
      this.milestoneInput.details.eventLocation =
      matchedLocation[0].combinedAddress;
    }
  }

  @Watch('milestoneInput', { deep: true })
  private update(milestoneInput: MilestoneInput) {
    if (!this.showModal) {
      this.debouncer(this);
    }
  }
}
